import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormErrorsComponent } from './form-errors/form-errors.component';
import { EditLockBannerComponent } from './edit-lock-banner/edit-lock-banner.component';
import { GrantDirective } from './directives/grant.directive';
import { ModalInputTextComponent } from './modal-input-text/modal-input-text.component';
import { ModalSelectAgreementProductComponent } from './modal-select-agreement-product/modal-select-agreement-product.component';
import { ModalRepairReturnComponent } from './modal-repair-return/modal-repair-return.component';
import { PrimeModule } from '../prime/prime.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ProductCategoriesTreeComponent } from './product-categories-tree/product-categories-tree.component';
import { ModalProdPickerComponent } from './modal-prod-picker/modal-prod-picker.component';
import { ModalInputCategoriesComponent } from './modal-input-categories/modal-input-categories.component';
import { ModalOfficeTypeComponent } from './modal-office-type/modal-office-type.component';
import { ModalDdtSubjectComponent } from './modal-ddt-subject/modal-ddt-subject.component';
import { ModalRegPickerComponent } from './modal-reg-picker/modal-reg-picker.component';
import { ModalAddressBookPickerComponent } from './modal-address-book-picker/modal-address-book-picker.component';
import { ModalUserPickerComponent } from './modal-user-picker/modal-user-picker.component';
import { InputRegistryPickerComponent } from './input-registry-picker/input-registry-picker.component';
import { ModalServiceFormComponent } from './modal-service-form/modal-service-form.component';
import { ModalServicePickerComponent } from './modal-service-picker/modal-service-picker.component';
import { ModalServicePricingComponent } from './modal-service-pricing/modal-service-pricing.component';
import { InputOfficePickerComponent } from './input-office-picker/input-office-picker.component';
import { ModalImagePickerComponent } from './modal-image-picker/modal-image-picker.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { WorkflowTypePipe } from './pipes/workflowTypePipe.pipe';
import { ModalWorkflowPickerComponent } from './modal-workflow-picker/modal-workflow-picker.component';
import { IdToContactPipe } from './pipes/id-to-contact.pipe';
import { WorkflowStatusPipe } from './pipes/workflow-status.pipe';
import { ModalStatusChangeComponent } from './modal-status-change/modal-status-change.component';
import { ModalCorrectStatusComponent } from './modal-correct-status/modal-correct-status.component';
import { WorkflowTransitionEventTypePipe } from './pipes/workflow-transition-event-type.pipe';
import { ModalAgreementProdPickerComponent } from './modal-agreement-prod-picker/modal-agreement-prod-picker.component';
import { AdditionalServicePipe } from './pipes/additional-service.pipe';
import { ModalMovementHistoryComponent } from './modal-movement-history/modal-movement-history.component';
import { ModalSpecialMoveComponent } from './modal-special-move/modal-special-move.component';
import { ModalDisposeRaeeComponent } from './modal-dispose-raee/modal-dispose-raee.component';
import { ModalContactHistoryComponent } from './modal-contact-history/modal-contact-history.component';
import { ModalDataHistoryComponent } from './modal-data-history/modal-data-history.component';
import { ModalSerialInStockComponent } from './modal-serial-in-stock/modal-serial-in-stock.component';
import { ModalManageSerialsStagingComponent } from './modal-manage-serials-staging/modal-manage-serials-staging.component';
import { ModalEditScheduleComponent } from './modal-edit-schedule/modal-edit-schedule.component';
import { ModalRegistryFormComponent } from './modal-registry-form/modal-registry-form.component';
import { ModalAddressBookFormComponent } from './modal-address-book-form/modal-address-book-form.component';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { WarehouseModalComponent } from './warehouse-modal/warehouse-modal.component';
import { ModalDeliveryProductsPickerComponent } from './modal-delivery-products-picker/modal-delivery-products-picker.component';
import { ModalManageSchedulesComponent } from './modal-manage-schedules/modal-manage-schedules.component';
import { FieldTypePipe } from './pipes/field-type.pipe';
import { ChunkifyPipe } from './pipes/chunkify.pipe';
import { SerialsButtonComponent } from './serials-button/serials-button.component';
import { ModalDeliveryHistoryComponent } from './modal-delivery-history/modal-delivery-history.component';
import { DdtHistoryTableComponent } from './ddt-history-table/ddt-history-table.component';
import { ModalDdtHistoryComponent } from './modal-ddt-history/modal-ddt-history.component';
import { ModalTransferSparePartsComponent } from './modal-transfer-spare-parts/modal-transfer-spare-parts.component';
import { ModalSelectSerialsComponent } from './modal-select-serials/modal-select-serials.component';
import { ModalTicketIntegrationNotesComponent } from './modal-ticket-integration-notes/modal-ticket-integration-notes.component';
import { AttachmentsDrawerComponent } from './attachments-drawer/attachments-drawer.component';
import { TicketIntegrationNotesPanelComponent } from './ticket-integration-notes-panel/ticket-integration-notes-panel.component';
import { DuplicationPipe } from './pipes/duplication.pipe';
import { CommonService } from '../api/services';
import { FilesizePipe } from './pipes/filesize.pipe';
import { ModalUploadComponent } from './modal-upload/modal-upload.component';
import { CalculateSlaPipe } from './pipes/calculate-sla.pipe';
import { NumberToTimePipe } from './pipes/number-to-time.pipe';
import { ToNumberPipe } from './pipes/to-number.pipe';
import { RegistryPrintPipe } from './pipes/registry-print.pipe';
import { ModalReplaceAssetManagementComponent } from './modal-replace-asset-management/modal-replace-asset-management.component';
import { ModalReverseReplaceAssetManagementComponent } from './modal-reverse-replace-asset-management/modal-reverse-replace-asset-management.component';
import { NgChartsModule } from 'ng2-charts';
import { IpMaskDirective } from '../utils/directives/ip-segment-jump.directive';
import { ModalChangeTicketTagComponent } from './modal-change-ticket-tag/modal-change-ticket-tag.component';
import { OnlyStagingPipe } from './pipes/only-staging.pipe';
import { FormDebugInspectorComponent } from './form-debug-inspector/form-debug-inspector.component';
import { ModalReplacementHistoryComponent } from './modal-replacement-history/modal-replacement-history.component';
import { ModalSearchBySerialComponent } from './modal-search-by-serial/modal-search-by-serial.component';
import { LicenseStatusPipe } from './pipes/license-status.pipe';
import { ModalEmailStatusConfigComponent } from './modal-email-status-config/modal-email-status-config.component';
import { ModalReplaceOrderProductComponent } from './modal-replace-order-product/modal-replace-order-product.component';
import { HttpClientModule } from '@angular/common/http';
import { ModalConfirmDeliveryAddressComponent } from './modal-confirm-delivery-address/modal-confirm-delivery-address.component';
import { DynamicFieldsMenuComponent } from './dynamic-fields-menu/dynamic-fields-menu.component';
import { ModalEmailNotificationConfigComponent } from './modal-email-notification-config/modal-email-notification-config.component';
import { AssetUtilizzoPipe } from './pipes/asset-utilizzo.pipe';

@NgModule({
  declarations: [
    EditLockBannerComponent,
    IpMaskDirective,
    FormErrorsComponent,
    GrantDirective,
    ModalInputTextComponent,
    ModalSpecialMoveComponent,
    ModalDisposeRaeeComponent,
    ModalSelectAgreementProductComponent,
    ModalRepairReturnComponent,
    ProductCategoriesTreeComponent,
    ModalProdPickerComponent,
    ModalInputCategoriesComponent,
    ModalOfficeTypeComponent,
    ModalDdtSubjectComponent,
    ModalRegPickerComponent,
    ModalAddressBookPickerComponent,
    ModalUserPickerComponent,
    InputRegistryPickerComponent,
    ModalServiceFormComponent,
    ModalServicePickerComponent,
    ModalServicePricingComponent,
    InputOfficePickerComponent,
    ModalImagePickerComponent,
    WorkflowTypePipe,
    ModalWorkflowPickerComponent,
    IdToContactPipe,
    ModalStatusChangeComponent,
    ModalCorrectStatusComponent,
    IdToContactPipe,
    WorkflowStatusPipe,
    WorkflowTransitionEventTypePipe,
    ModalAgreementProdPickerComponent,
    AdditionalServicePipe,
    ModalMovementHistoryComponent,
    ModalContactHistoryComponent,
    ModalDataHistoryComponent,
    ModalSerialInStockComponent,
    ModalManageSerialsStagingComponent,
    ModalEditScheduleComponent,
    ModalRegistryFormComponent,
    ModalAddressBookFormComponent,
    WarehouseModalComponent,
    ModalDeliveryProductsPickerComponent,
    ModalManageSchedulesComponent,
    FieldTypePipe,
    ChunkifyPipe,
    SerialsButtonComponent,
    ModalDeliveryHistoryComponent,
    DdtHistoryTableComponent,
    ModalDdtHistoryComponent,
    ModalTransferSparePartsComponent,
    ModalSelectSerialsComponent,
    ModalTicketIntegrationNotesComponent,
    AttachmentsDrawerComponent,
    TicketIntegrationNotesPanelComponent,
    DuplicationPipe,
    FilesizePipe,
    ModalUploadComponent,
    CalculateSlaPipe,
    NumberToTimePipe,
    ToNumberPipe,
    RegistryPrintPipe,
    ModalReplaceAssetManagementComponent,
    ModalReverseReplaceAssetManagementComponent,
    ModalChangeTicketTagComponent,
    OnlyStagingPipe,
    FormDebugInspectorComponent,
    ModalReplacementHistoryComponent,
    ModalSearchBySerialComponent,
    LicenseStatusPipe,
    ModalEmailStatusConfigComponent,
    ModalReplaceOrderProductComponent,
    ModalConfirmDeliveryAddressComponent,
    DynamicFieldsMenuComponent,
    ModalEmailNotificationConfigComponent,
    AssetUtilizzoPipe,
  ],
  exports: [
    EditLockBannerComponent,
    IpMaskDirective,
    FormErrorsComponent,
    GrantDirective,
    ModalInputTextComponent,
    ModalSpecialMoveComponent,
    ModalDisposeRaeeComponent,
    ModalSelectAgreementProductComponent,
    ModalRepairReturnComponent,
    ProductCategoriesTreeComponent,
    ModalProdPickerComponent,
    ModalInputCategoriesComponent,
    ModalOfficeTypeComponent,
    ModalDdtSubjectComponent,
    ModalRegPickerComponent,
    ModalAddressBookPickerComponent,
    ModalUserPickerComponent,
    InputRegistryPickerComponent,
    ModalServiceFormComponent,
    ModalServicePickerComponent,
    ModalServicePricingComponent,
    InputOfficePickerComponent,
    ModalImagePickerComponent,
    WorkflowTypePipe,
    ModalWorkflowPickerComponent,
    IdToContactPipe,
    ModalStatusChangeComponent,
    ModalCorrectStatusComponent,
    IdToContactPipe,
    WorkflowStatusPipe,
    WorkflowTransitionEventTypePipe,
    ModalAgreementProdPickerComponent,
    AdditionalServicePipe,
    ModalMovementHistoryComponent,
    ModalContactHistoryComponent,
    ModalDataHistoryComponent,
    ModalSerialInStockComponent,
    ModalManageSerialsStagingComponent,
    ModalEditScheduleComponent,
    ModalRegistryFormComponent,
    ModalAddressBookFormComponent,
    WarehouseModalComponent,
    ModalDeliveryProductsPickerComponent,
    ModalManageSchedulesComponent,
    FieldTypePipe,
    ChunkifyPipe,
    SerialsButtonComponent,
    ModalDeliveryHistoryComponent,
    DdtHistoryTableComponent,
    ModalDdtHistoryComponent,
    ModalTransferSparePartsComponent,
    ModalSelectSerialsComponent,
    ModalTicketIntegrationNotesComponent,
    AttachmentsDrawerComponent,
    TicketIntegrationNotesPanelComponent,
    DuplicationPipe,
    FilesizePipe,
    CalculateSlaPipe,
    NumberToTimePipe,
    ToNumberPipe,
    RegistryPrintPipe,
    NgChartsModule,
    OnlyStagingPipe,
    FormDebugInspectorComponent,
    ModalReplacementHistoryComponent,
    ModalSearchBySerialComponent,
    LicenseStatusPipe,
    ModalEmailStatusConfigComponent,
    ModalReplaceOrderProductComponent,
    ModalConfirmDeliveryAddressComponent,
    DynamicFieldsMenuComponent,
    ModalEmailNotificationConfigComponent,
    AssetUtilizzoPipe,
  ],
  providers: [CommonService],
  imports: [
    CommonModule,
    PrimeModule,
    ReactiveFormsModule,
    ImageCropperModule,
    NgChartsModule,
    ClipboardModule,
    HttpClientModule,
  ],
})
export class SharedModule {}
